import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { useAuth } from '@leagueplatform/auth-utils';

/**
 * Authed wrapper for pre-onboarding routes (market/persona selection).
 * Mirrors AuthSessionContainer's sign-in gate — including the auth-error
 * redirect to the landing page — but skips PrivateRoutesContainer so we
 * bypass BasePage's full chrome (nav bar, health-assessment prompt,
 * caregiver banner, live-chat). Pre-onboarding pages render inside
 * PreOnboardingLayout instead.
 */
export const AuthedPreOnboardingContainer = () => {
  const { isAuthenticated, error } = useAuth({
    redirectToLogInWhenSignedOut: true,
  });

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (error) {
      const urlErrorParams = new URLSearchParams();
      urlErrorParams.append('error', error.type);
      if (error.description) {
        urlErrorParams.append('error_description', error.description);
      }

      navigate(`/?${urlErrorParams}`, { replace: true });
    }
  }, [error, navigate, location]);

  if (!isAuthenticated) return <LoadingIndicator />;

  return <Outlet />;
};
